import { Component, Input } from '@angular/core'
import { environment } from 'src/environments/environment'
import { OrderList } from '../../models/order.model'
import { TranslateService } from '@ngx-translate/core'
import { SharedService } from 'src/app/shared/services/shared.service'
import { StatusDeliverOrderEnum } from '../../models/order.enum'
import { HistoryStatusPopupComponent } from '../history-status-popup/history-status-popup.component'
import { MatDialog } from '@angular/material/dialog'

@Component({
	selector: 'app-orders-table',
	templateUrl: './orders-table.component.html',
	styleUrl: './orders-table.component.scss',
})
export class OrdersTableComponent {
	dataHover: boolean = false
	@Input() ordersList!: OrderList[]
	@Input() totalCount!: number
	@Input() orderFilter: any = {
		paging: { pageNumber: 1, pageSize: 10 },

		countryId: 224,
		searchText: '',
		orderStatus: 1,
	}

	attachmentUrl = environment.attachmentPath
	hoverId!: number | null
	orderDeliverStatus = this.sharedServ.returnEnumArray(StatusDeliverOrderEnum)

	constructor(
		public translate: TranslateService,
		private sharedServ: SharedService,
		private dialog: MatDialog
	) {}

	ngOnInit(): void {}

	openStatus(order: OrderList) {
		this.dialog
			.open(HistoryStatusPopupComponent, {
				width: '600px',
				// height: '450px',
				autoFocus: false,

				data: {
					historyData: order?.statusHistory,
				},
			})
			.afterClosed()
			.subscribe({})
	}
}
